import { initializeApp } from 'firebase/app';
import {
  getRemoteConfig,
  getString,
  fetchAndActivate,
  getValue,
} from 'firebase/remote-config';
import { config } from '../../config';
import {
  getAnalytics,
  setAnalyticsCollectionEnabled,
  setConsent,
} from 'firebase/analytics';
import { firebaseDefaultConsentSettings } from './consentSettings';
const remoteConfigParams: {
  [key: string]: string;
} = {
  dev: 'v2_countries_debug_TENANT',
  stg: 'v2_countries_beta_TENANT',
  prd: 'v2_countries_TENANT',
};

const app = initializeApp(config.firebaseConfiguration!, {
  automaticDataCollectionEnabled: false,
});

// Disable automatic data collection initially.
// In useGoogleAnalytics hook, it's set based on user consent
setConsent(firebaseDefaultConsentSettings);
setAnalyticsCollectionEnabled(getAnalytics(app), false);

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 60 * 60 * 1000;

const getConfigName = (tenant: string): string => {
  const configName = remoteConfigParams[config.env].replace(
    'TENANT',
    tenant.toUpperCase()
  );
  return configName;
};

export const getRemoteData = async (tenant: string): Promise<string> => {
  await fetchAndActivate(remoteConfig);
  const configName = getConfigName(tenant);
  return getString(remoteConfig, configName);
};

export const getRemoteJson = async (
  key: string
): Promise<Record<string, unknown>> => {
  await fetchAndActivate(remoteConfig);
  const value = await getValue(remoteConfig, key);
  return JSON.parse(value.asString());
};

export const firebaseApp = app;
